import { render, staticRenderFns } from "./AddSlider.vue?vue&type=template&id=5d6dbfa8"
import script from "./AddSlider.vue?vue&type=script&lang=js"
export * from "./AddSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports